// Calendar export for plans: Google/Outlook web deep links (no popup needed,
// just a normal link) plus a downloadable .ics that covers Apple Calendar
// and everything else. Plans have no explicit end time, so we default to a
// 2-hour block.

const DEFAULT_DURATION_SEC = 2 * 60 * 60;

function planWindow(plan) {
  const start = plan.scheduledFor;
  return { start, end: start + DEFAULT_DURATION_SEC };
}

function planLocation(place) {
  return place?.address || place?.name || '';
}

function planDescription(plan, place) {
  const lines = [];
  if (plan.note) lines.push(plan.note);
  if (place?.name) lines.push(`Larkle plan: ${place.name}`);
  return lines.join('\n\n');
}

// UTC, no separators — the format both Google and .ics want: YYYYMMDDTHHMMSSZ
function utcStamp(unixSeconds) {
  return new Date(unixSeconds * 1000).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
}

export function googleCalendarUrl(plan, place) {
  const { start, end } = planWindow(plan);
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: plan.title || 'Plan',
    dates: `${utcStamp(start)}/${utcStamp(end)}`,
    details: planDescription(plan, place),
    location: planLocation(place),
  });
  return `https://calendar.google.com/calendar/render?${params}`;
}

export function outlookCalendarUrl(plan, place) {
  const { start, end } = planWindow(plan);
  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: plan.title || 'Plan',
    startdt: new Date(start * 1000).toISOString(),
    enddt: new Date(end * 1000).toISOString(),
    body: planDescription(plan, place),
    location: planLocation(place),
  });
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params}`;
}

function icsEscape(s = '') {
  return s.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
}

export function icsFileContent(plan, place) {
  const { start, end } = planWindow(plan);
  const location = planLocation(place);
  const description = planDescription(plan, place);
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Larkle//Plan//EN',
    'BEGIN:VEVENT',
    `UID:${plan.id}@larkle`,
    `DTSTAMP:${utcStamp(Math.floor(Date.now() / 1000))}`,
    `DTSTART:${utcStamp(start)}`,
    `DTEND:${utcStamp(end)}`,
    `SUMMARY:${icsEscape(plan.title || 'Plan')}`,
    location ? `LOCATION:${icsEscape(location)}` : null,
    description ? `DESCRIPTION:${icsEscape(description)}` : null,
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean).join('\r\n');
}

export function downloadIcs(plan, place) {
  const blob = new Blob([icsFileContent(plan, place)], { type: 'text/calendar' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${(plan.title || 'plan').replace(/[^\w-]+/g, '-').toLowerCase()}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
